import { StoreState } from '@/core/models/store.interface';
import i18n from '@/i18n';
import { Module } from 'vuex';
import { PropertyType } from './property-type.interface';
import propertyTypeService from './property-type.service';

export interface PropertyTypeState { }

const PropertyTypeStore: Module<PropertyTypeState, StoreState> = {
   namespaced: true,

   state: {},

   getters: {},

   mutations: {},

   actions: {
      async delete(context, property_type_id: number) {
         return await propertyTypeService.delete(property_type_id).then((response) => {
            context.commit('board/deletePropertyTypeFromBoard', { property_type_id }, { root: true });
            return response;
         });
      },
      async post(context, { board_id, property_type }: { board_id: number; property_type: PropertyType }) {
         const body = property_type;
         body['board_id'] = board_id;

         return propertyTypeService.post(body).then((response) => {
            context.commit('board/updatePropertyTypeFromBoard', { property_type: response }, { root: true });

            context.dispatch(
               'addNotification',
               {
                  notification: {
                     type: 'success',
                     message: `${i18n.global.t('services.parameter_saved')}`,
                  },
               },
               { root: true },
            );
            return response;
         });
      },
      async patches(context, { property_type_id, patches }: { property_type_id: number; patches: Array<{ path: string; value: any }> }) {
         const BODY = patches.map((patch) => {
            return {
               op: 'replace',
               path: patch.path,
               value: patch.value,
            };
         });

         return await propertyTypeService.patch(property_type_id, BODY).then((response) => response);
      },
   },
};

export default PropertyTypeStore;
